import React from "react";

const CreditFreezeDialog = (props: any) => {
    return (
        <>
            <div className="dialog-header">
                <div
                    className="dialog-icon status-default"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <span>
                        <em className="las la-snowflake"></em>
                    </span>
                </div>
                <div className="box-title-text">
                    <h2 className="box-title">Your Report is Frozen</h2>
                </div>
            </div>
            <div className="dialog-body">
                <div className="row">
                    <p className="credit-freeze-text">
                        Looks like you're trying to lock your credit report while you have a freeze on it. Please unfreeze your credit report first at
                        <a
                            className="default_link link"
                            style={{ paddingLeft: "5px" }}
                            href="https://www.TransUnion.com/credit-freeze"
                            id="btn-leave-feedback"
                            target="_blank"
                            rel="noreferrer"
                            onClick={(e: any) => {
                                e.stopPropagation();
                            }}
                        >
                            TransUnion.com/credit-freeze
                        </a>
                        .
                    </p>
                    <p className="credit-freeze-text">
                        Credit Lock protects your file like a credit freeze, but you can lock and unlock your report instantly and get alerts when someone tries to
                        access it.
                    </p>
                </div>
            </div>
            <div className="dialog-footer">
                <div className="row flex-end">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={props.closeDialog}>
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreditFreezeDialog;
